import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { changeAppointmentData } from "../../../StateManagement/Reducers/AppointmentsState";
import { Select, DatePicker, TimePicker } from "antd";
import dayjs from "dayjs";
import { SmallDatePickerStyle } from "./StyledComponents";
import {
  getPatientTimezone,
  getPatientCurrentDateTime,
  convertPatientTimeToProviderTime,
  isSlotDisabledForPatient,
} from "../../utils/RepeatFunctions/Timezone";
import {
  getFacilityList,
  getProvidersList,
  addAppointment,
  GetUpcomingAppointment,
  getProviderAvailablity,
  changeTime,
  GetBillingFacility,
  appointmentSaved,
  AppointmentEdited,
  clearAppointmentData,
  changeErrorObject,
  addAppointmentWaitList,
  editAppointmentWaitList,
  waitListAppointmentSaved,
} from "../../../StateManagement/Reducers/AppointmentsState";
import {
  AntdDateWrapper,
  AntdSelectWrapper,
  ModalInput,
} from "./StyledComponents";
import { Decrypt_Value } from "../../../MiddleWare/EncryptDecrypt";

const { Option } = Select;

const AddAppointmentFormModal = ({ onClose, onSave }) => {
  const dispatch = useDispatch();

  const [savebtndisabled, setsavebtndisabled] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [facilityErr, setFacilityErr] = useState(false);
  const [specialityErr, setSpecialityErr] = useState(false);
  const [apptTypeErr, setApptTypeErr] = useState(false);
  const [providerErr, setProviderErr] = useState(false);
  const [aptDateErr, setAptDateErr] = useState(false);
  const [aptTimeErr, setAptTimeErr] = useState(false);
  const [priorityErr, setPriorityErr] = useState(false);
  const [dateErr, setDateErr] = useState(false);
  const [duplicateErr, setDuplicateErr] = useState(false);
  const [fromTimeError, setFromTimeError] = useState("");
  const [toTimeError, setToTimeError] = useState("");
  const [activeSection, setActiveSection] = useState("morning");
  const {
    appointmentData,
    facilityList,
    providersList,
    providerAvailablity,
    loadingOffice,
    loadingProviders,
  } = useSelector((state) => state.Appointments);

  const errorTextStyle = {
    color: "#F65160",
    fontSize: "12px",
    marginTop: "4px",
  };

  const bill_facility_id = useSelector(
    (state) => state.Appointments.BillingFacility,
  );

  const pid =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  const patientCurrent = getPatientCurrentDateTime();

  const patientToday = patientCurrent.date;
  const patientNow = patientCurrent.time;

  // console.log("Patient Timezone:", getPatientTimezone());
  // console.log("Patient Today:", patientToday);
  // console.log("Patient Now:", patientNow);

  /* ---------- COMMON STYLES ---------- */

  const labelStyle = {
    fontSize: "13px",
    fontWeight: 500,
    marginBottom: "6px",
    color: "#1f2937",
  };
  const upcomingAppointments = useSelector(
    (state) => state.Appointments.upcomingAppointment ?? [],
  );
  const AppointmentLists = useSelector(
    (state) => state.Appointments.upcomingAppointment,
  );
  // console.log(upcomingAppointments, "uah", AppointmentLists);
  // useEffect(() => {
  //   console.log("=== DEBUGGING SCHEDULE DATA ===");
  //   console.log("1. Raw Provider Availability (Slots):", providerAvailablity);
  //   console.log("2. Upcoming Appointments (Booked):", upcomingAppointments);
  //   console.log("===============================");
  // }, [providerAvailablity, upcomingAppointments]);

  const isDuplicateAppointment = () => {
    return upcomingAppointments.some((appt) => {
      const sameProvider =
        Number(appt.pc_aid) === Number(appointmentData.provider);

      // Use eventDate ("2026-05-25") not pc_eventDate ("Monday 25 May 2026")
      // const sameDate = appt.eventDate === appointmentData.aptdate;
      const sameDate =
        (appt.ApptFromDate || appt.eventDate) === appointmentData.aptdate;

      // Normalize both times to "HH:MM AM/PM" format for safe comparison
      const normalize = (t) => (t ? t.trim().toUpperCase() : "");
      const sameTime =
        normalize(appt.pc_startTime) === normalize(appointmentData.apttime);

      // Skip the check if we're editing this exact appointment
      const notCurrentEdit =
        !appointmentData.eid ||
        String(appt.pc_eid) !== String(appointmentData.eid);

      return sameProvider && sameDate && sameTime && notCurrentEdit;
    });
  };
  const availability = providerAvailablity ?? {};

  const timeSections = [
    { key: "morning", label: "Morning" },
    { key: "afternoon", label: "Afternoon" },
    { key: "evening", label: "Evening" },
  ];

  const selectStyle = {
    width: "100%",
  };

  const [isWaitListChecked, setIsWaitListChecked] = useState(false);

  const [waitListExtraInputs, setWaitListExtraInputs] = useState({
    priority: "",
    date: appointmentData.aptdate || "",
    fromTime: "",
    toTime: "",
  });

  const specialityList = [
    { id: 1, value: "Plastic Surgery", name: "Plastic Surgery" },
    { id: 2, value: "Dermatology", name: "Dermatology" },
    { id: 3, value: "Sleep Medicine", name: "Sleep Medicine" },
    { id: 4, value: "Allergy & Immunology", name: "Allergy & Immunology" },
    { id: 5, value: "Concierge Medicine", name: "Concierge Medicine" },
    { id: 6, value: "Oncology", name: "Oncology" },
    { id: 7, value: "Palliative Care", name: "Palliative Care" },
    { id: 8, value: "Endocrinology", name: "Endocrinology" },
    { id: 9, value: "Sports Medicine", name: "Sports Medicine" },
    { id: 11, value: "Hospice", name: "Hospice" },
    { id: 12, value: "Pediatrics", name: "Pediatrics" },
    { id: 13, value: "Pathology", name: "Pathology" },
    {
      id: 14,
      value: "Obstetrics and Gynecology",
      name: "Obstetrics and Gynecology",
    },
    { id: 15, value: "Hand Surgery", name: "Hand Surgery" },
    { id: 16, value: "Hematology", name: "Hematology" },
    { id: 17, value: "Emergency Medicine", name: "Emergency Medicine" },
    { id: 18, value: "Surgery", name: "Surgery" },
    { id: 19, value: "Cardiology", name: "Cardiology" },
    { id: 20, value: "Vascular Surgery", name: "Vascular Surgery" },
    { id: 21, value: "Pulmonology", name: "Pulmonology" },
    { id: 22, value: "Radiology", name: "Radiology" },
    { id: 23, value: "ECG Management", name: "ECG Management" },
    {
      id: 24,
      value: "Physical Medicine & Rehabilitation",
      name: "Physical Medicine & Rehabilitation",
    },
    { id: 25, value: "Ophthalmology", name: "Ophthalmology" },
    { id: 26, value: "Geriatric Medicine", name: "Geriatric Medicine" },
    { id: 27, value: "Neurology", name: "Neurology" },
    { id: 28, value: "Infectious Disease", name: "Infectious Disease" },
    { id: 29, value: "Nephrology", name: "Nephrology" },
    {
      id: 30,
      value: "Ambulatory Care & Surgery",
      name: "Ambulatory Care & Surgery",
    },
    { id: 31, value: "Otolaryngology (ENT)", name: "Otolaryngology (ENT)" },
    { id: 32, value: "Dental Health", name: "Dental Health" },
    { id: 33, value: "Chiropractic", name: "Chiropractic" },
    { id: 34, value: "Psychiatry", name: "Psychiatry" },
    { id: 35, value: "Urology", name: "Urology" },
    { id: 36, value: "Wound Care", name: "Wound Care" },
    { id: 37, value: "Orthopedic Surgery", name: "Orthopedic Surgery" },
    { id: 38, value: "Behaviour Health", name: "Behaviour Health" },
    { id: 39, value: "Gastroenterology", name: "Gastroenterology" },
    { id: 40, value: "Anesthesiology", name: "Anesthesiology" },
    { id: 41, value: "Family Medicine", name: "Family Medicine" },
    { id: 42, value: "Podiatry", name: "Podiatry" },
    { id: 43, value: "Austism", name: "Austism" },
    { id: 44, value: "Rheumatology", name: "Rheumatology" },
    { id: 45, value: "Acupuncture", name: "Acupuncture" },
    { id: 46, value: "Opthalmology", name: "Opthalmology" },
    {
      id: 47,
      value: "Behavioral health therapy",
      name: "Behavioral health therapy",
    },
    {
      id: 48,
      value: "Lactation consulting",
      name: "Lactation consulting",
    },
    {
      id: 49,
      value: "Massage therapy",
      name: "Massage therapy",
    },
    {
      id: 50,
      value: "Counseling",
      name: "Counseling",
    },
    {
      id: 51,
      value: "Marriage and family therapy",
      name: "Marriage and family therapy",
    },
    {
      id: 52,
      value: "Psychology",
      name: "Psychology",
    },
    {
      id: 53,
      value: "Social work",
      name: "Social work",
    },
    {
      id: 54,
      value: "Dietetics or nutrition counseling",
      name: "Dietetics or nutrition counseling",
    },
    {
      id: 55,
      value: "Applied behavior analysis",
      name: "Applied behavior analysis",
    },
    {
      id: 56,
      value: "Occupational therapy",
      name: "Occupational therapy",
    },
    {
      id: 57,
      value: "Physical therapy",
      name: "Physical therapy",
    },
    {
      id: 58,
      value: "Speech-language pathology",
      name: "Speech-language pathology",
    },
    {
      id: 59,
      value: "Substance use counseling",
      name: "Substance use counseling",
    },
    { id: 10, value: "Other", name: "Other" },
  ];

  //Changed appoitment id into 0 to match the provider portal
  const apptTypeList = [
    { id: 0, name: "Appointment" },
    { id: 2, name: "Telehealth" },
  ];

  useEffect(() => {
    dispatch(getFacilityList({ find: "" }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(GetBillingFacility());
  }, [dispatch]);

  useEffect(() => {
    if (appointmentData.office) {
      dispatch(
        getProvidersList({
          name: "",
          facility_id: appointmentData.office,
          pid: pid, // 👈 decrypted PID
          selectSpeciality: appointmentData.speciality,
          appttype: appointmentData.appttype,
          scheduled_provider_id: appointmentData.provider,
        }),
      );
      console.log("Providers list:", providersList);
    }
  }, [
    appointmentData.office,
    appointmentData.speciality,
    appointmentData.appttype,
    pid,
  ]);

  // useEffect(() => {
  //   console.log("Updated Providers List for Speciality:", appointmentData.speciality, providersList);
  // }, [providersList, appointmentData.speciality]);

  useEffect(() => {
    if (appointmentData?.changeUrl?.length > 0) {
      onClose();
    }
  }, [appointmentData?.changeUrl, onClose]);

  useEffect(() => {
    if (appointmentData && appointmentData.type === "waitlist") {
      // 1. Check the Waitlist box automatically
      setIsWaitListChecked(true);

      // 2. Map the priority number back to the dropdown string
      const reversePriorityMap = {
        1: "Urgent",
        2: "High",
        3: "Medium",
        4: "Low",
      };
      const mappedPriority = reversePriorityMap[appointmentData.priority] || "";

      // 3. Extract the "From" and "To" times from the string (e.g., "06:00 PM - 06:10 PM")
      let fromT = "";
      let toT = "";
      if (appointmentData.Time) {
        const timeSplit = appointmentData.Time.split(" - ");
        if (timeSplit.length === 2) {
          // Convert "06:00 PM" into the "18:00" format your TimePicker expects
          fromT = dayjs(timeSplit[0], "hh:mm A").format("HH:mm");
          toT = dayjs(timeSplit[1], "hh:mm A").format("HH:mm");
        }
      }

      // 4. Fill the waitlist UI state
      setWaitListExtraInputs({
        priority: mappedPriority,
        fromTime: fromT,
        toTime: toT,
        date: appointmentData.aptdate || appointmentData.eventDate || "",
      });
    } else {
      // If it is a normal appointment, ensure the waitlist box stays unchecked
      setIsWaitListChecked(false);
      setWaitListExtraInputs((prev) => ({
        ...prev,
        date: appointmentData?.aptdate || "",
      }));
    }
  }, [
    appointmentData?.id,
    appointmentData?.eid,
    appointmentData?.type,
    appointmentData?.priority,
    appointmentData?.Time,
    appointmentData?.aptdate,
    appointmentData?.eventDate,
  ]);

  const isEditing =
    (appointmentData?.eid && appointmentData.eid !== 0) ||
    (appointmentData?.id && appointmentData.id !== 0);

  useEffect(() => {
    if (
      appointmentData.provider &&
      appointmentData.office &&
      appointmentData.aptdate
    ) {
      const providerObj = providersList?.find(
        (p) => Number(p.id) === Number(appointmentData.provider)
      );
      const providerTimezone = providerObj?.timezone || null;
      const patientTimezone = getPatientTimezone();

      dispatch(
        getProviderAvailablity({
          pc_aid: appointmentData.provider,
          pc_facility: appointmentData.office,
          date: appointmentData.aptdate,
          appttype: appointmentData.appttype === "Telehealth" ? 2 : 0, //Changes 1 into 0 cause of provider portal
          patient_timezone: patientTimezone,
          provider_timezone: providerTimezone,
        }),
      );
    }
  }, [
    appointmentData.provider,
    appointmentData.office,
    appointmentData.aptdate,
    appointmentData.appttype,
    providersList,
  ]);

  // useEffect(() => {
  //   if (
  //     !appointmentData.provider &&
  //     !appointmentData.office &&
  //     !appointmentData.apttime &&
  //     appointmentData.eid === 0
  //   ) {
  //     onClose();
  //   }
  // }, [
  //   appointmentData.provider,
  //   appointmentData.office,
  //   appointmentData.apttime,
  //   appointmentData.eid,
  //   onClose,
  // ]);
  const validateTimeRange = (fromTime, toTime) => {
    setToTimeError("");

    if (fromTime && toTime) {
      const from = dayjs(fromTime, "HH:mm");
      const to = dayjs(toTime, "HH:mm");

      if (!to.isAfter(from)) {
        setToTimeError("To Time must be higher than From Time.");
        return false;
      }
    }

    return true;
  };

  const saveWaitListAppointment = () => {
    let err = 0;

    if (!waitListExtraInputs.priority) {
      setPriorityErr(true);
      err = 1;
    } else {
      setPriorityErr(false);
    }

    if (!waitListExtraInputs.date) {
      setDateErr(true);
      err = 1;
    } else {
      setDateErr(false);
    }

    if (!waitListExtraInputs.fromTime) {
      setFromTimeError("Select From Time");
      err = 1;
    }

    if (!waitListExtraInputs.toTime) {
      setToTimeError("Select To Time");
      err = 1;
    }

    // if (!appointmentData.provider || !appointmentData.office) {
    //   err = 1;
    // }

    if (!appointmentData.office) {
      setFacilityErr(true);
      err = 1;
    }
    if (!appointmentData.provider) {
      setProviderErr(true);
      err = 1;
    }
    if (!appointmentData.speciality) {
      setSpecialityErr(true);
      err = 1;
    }
    if (!appointmentData.appttype) {
      setApptTypeErr(true);
      err = 1;
    }

    if (err > 0) {
      setsavebtndisabled(false);
      return;
    }

    const appttypenew = appointmentData.appttype === "Telehealth" ? 2 : 0; // Changed 1 to 0

    const priorityMap = {
      Urgent: 1,
      High: 2,
      Medium: 3,
      Low: 4,
    };

    const priorityValue =
      typeof waitListExtraInputs.priority === "number"
        ? waitListExtraInputs.priority
        : priorityMap[waitListExtraInputs.priority] || "";

    const providerObj = providersList?.find(
      (p) => Number(p.id) === Number(appointmentData.provider),
    );
    const providerTimezone = providerObj?.timezone || null;

    const fromTimeConverted = convertPatientTimeToProviderTime(
      waitListExtraInputs.date,
      waitListExtraInputs.fromTime,
      providerTimezone,
      "YYYY-MM-DD HH:mm",
    );

    const toTimeConverted = convertPatientTimeToProviderTime(
      waitListExtraInputs.date,
      waitListExtraInputs.toTime,
      providerTimezone,
      "YYYY-MM-DD HH:mm",
    );

    const fromDateTime = dayjs(
      `${waitListExtraInputs.date} ${waitListExtraInputs.fromTime}`,
      "YYYY-MM-DD HH:mm",
    );

    const toDateTime = dayjs(
      `${waitListExtraInputs.date} ${waitListExtraInputs.toTime}`,
      "YYYY-MM-DD HH:mm",
    );

    if (!toDateTime.isAfter(fromDateTime)) {
      setToTimeError("To Time must be higher than From Time.");
      setsavebtndisabled(false);
      return;
    }

    // if (fromDateTime.isBefore(dayjs())) {
    //   setFromTimeError("Cannot select past time");
    const patientCurrentDateTime = dayjs(
      `${patientToday} ${patientNow}`,
      "YYYY-MM-DD hh:mm A",
    );

    if (fromDateTime.isBefore(patientCurrentDateTime)) {
      setFromTimeError("Cannot select past time");
      setsavebtndisabled(false);
      return;
    }

    const article = {
      patient_id: pid,
      appt_type: appttypenew,
      facility: appointmentData.office,
      provider: appointmentData.provider,
      appt_date: fromTimeConverted.format("YYYY-MM-DD"),
      pref_start_time: fromTimeConverted.format("HH:mm"),
      pref_end_time: toTimeConverted.format("HH:mm"),
      priority: priorityValue,
      speciality: appointmentData.speciality,
      reason: appointmentData.reason,
      appt_profile: "",
      accepted: 0,
      id: appointmentData.id,
      notification: 0,
    };

    try {
      if (appointmentData.id === 0 || appointmentData.id === undefined) {
        //console.log("Data for waitlist", article);
        //return;
        dispatch(addAppointmentWaitList(article));
      } else {
        //console.log("Data for waitlist", article);
        //return;
        dispatch(editAppointmentWaitList(article));
      }
      onClose();
    } catch (error) {
      console.error("Error in waitlist:", error);
      setsavebtndisabled(false);
    }
  };

  return (
    <>
      <SmallDatePickerStyle />
      <div
        style={{
          width: "490px",
          maxHeight: "80vh",
          overflowY:
            isWaitListChecked ||
            (appointmentData.provider && appointmentData.aptdate)
              ? "auto"
              : "hidden",
          scrollbarWidth: "thin",
          paddingRight: "6px",
        }}
      >
        {/* ---------------- HEADER ---------------- */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "6px",
            paddingBottom: "0px",
          }}
        >
          <div
            style={{
              fontSize: "17px",
              fontWeight: 600,
              color: "#111827",
            }}
          >
            {isEditing ? "Edit Appointment" : "Create Appointment"}
          </div>

          <div
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={onClose}
          >
            ✕
          </div>
        </div>

        {/* ---------------- FACILITY ---------------- */}
        <div style={{ marginBottom: "8px" }}>
          <div style={labelStyle}>Facility</div>

          <Select
            status={facilityErr ? "error" : undefined}
            size="middle"
            style={selectStyle}
            placeholder="Select Facility"
            value={
              facilityList?.find(
                (f) => Number(f.id) === Number(appointmentData.office),
              )?.id
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            onChange={(val) => {
              setFacilityErr(false);
              dispatch(
                changeAppointmentData({ name: "office", value: Number(val) }),
              );

              dispatch(changeAppointmentData({ name: "provider", value: "" }));

              dispatch(changeTime(""));
              setActiveSection("morning");
            }}
          >
            {facilityList?.map((office) => (
              <Option key={office.id} value={office.id}>
                {office.name}
              </Option>
            ))}
          </Select>
          {facilityErr && <div style={errorTextStyle}>Select Facility</div>}
        </div>

        {/* ---------------- SPECIALITY + TYPE ---------------- */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "14px",
            marginBottom: "8px",
          }}
        >
          <div>
            <div style={labelStyle}>Speciality</div>

            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              status={specialityErr ? "error" : undefined}
              size="middle"
              style={selectStyle}
              placeholder="Select Speciality"
              value={
                specialityList.find(
                  (x) => String(x.name) === String(appointmentData.speciality),
                )?.id
              }
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(val) => {
                setSpecialityErr(false);
                const selected = specialityList.find(
                  (x) => Number(x.id) === Number(val),
                );

                dispatch(
                  changeAppointmentData({
                    name: "speciality",
                    value: selected?.name || "",
                  }),
                );

                dispatch(
                  changeAppointmentData({ name: "provider", value: "" }),
                );
                dispatch(changeTime(""));
                setActiveSection("morning");
              }}
            >
              {specialityList
                ?.filter((sp) => sp.name)
                ?.map((sp) => (
                  <Option key={sp.id} value={sp.id}>
                    {sp.name}
                  </Option>
                ))}
            </Select>
            {facilityErr && <div style={errorTextStyle}>Select Speciality</div>}
          </div>

          <div>
            <div style={labelStyle}>Appointment Type</div>

            <Select
              status={apptTypeErr ? "error" : undefined}
              size="middle"
              style={selectStyle}
              placeholder="Select Appointment Type"
              value={
                apptTypeList.find((x) => x.name === appointmentData.appttype)
                  ?.id
              }
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(val) => {
                setApptTypeErr(false);
                const selected = apptTypeList.find((x) => x.id === val);

                dispatch(
                  changeAppointmentData({
                    name: "appttype",
                    value: selected.name,
                  }),
                );
                dispatch(
                  changeAppointmentData({ name: "provider", value: "" }),
                );

                dispatch(changeTime(""));
                setActiveSection("morning");
              }}
            >
              {apptTypeList?.map((type) => (
                <Option key={type.id} value={type.id}>
                  {type.name}
                </Option>
              ))}
            </Select>
            {facilityErr && (
              <div style={errorTextStyle}>Select Appointment Type</div>
            )}
          </div>
        </div>

        {/* ---------------- PROVIDER ---------------- */}
        <div style={{ marginBottom: "8px" }}>
          <div style={labelStyle}>Provider</div>

          <Select
            status={providerErr ? "error" : undefined}
            size="middle"
            style={selectStyle}
            placeholder="Select Provider"
            value={
              providersList?.find(
                (p) => Number(p.id) === Number(appointmentData.provider),
              )?.id
            }
            getPopupContainer={(trigger) => trigger.parentNode}
            onChange={(val) => {
              setProviderErr(false);
              dispatch(changeAppointmentData({ name: "provider", value: val }));
              dispatch(changeTime(""));
            }}
          >
            {providersList?.map((prov) => (
              <Option key={prov.id} value={prov.id}>
                {prov.name}
              </Option>
            ))}
          </Select>
          {facilityErr && <div style={errorTextStyle}>Select Provider</div>}
        </div>

        {/* ---------------- DATE ---------------- */}
        {!isWaitListChecked && (
          <div className="appointment-modal" style={{ marginBottom: "8px" }}>
            <div style={labelStyle}>Date</div>

            <DatePicker
              format="MM-DD-YYYY"
              status={aptDateErr ? "error" : undefined}
              size="middle"
              style={{
                width: "100%",
                border: aptDateErr ? "1px solid #F65160" : undefined,
                borderRadius: aptDateErr ? "6px" : undefined,
              }}
              placeholder="Select Date"
              value={
                appointmentData.aptdate ? dayjs(appointmentData.aptdate) : null
              }
              disabledDate={(current) =>
                current && current < dayjs(patientToday).startOf("day")
              }
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={(date, dateString) => {
                setAptDateErr(false);
                const isoDateStr = date ? date.format("YYYY-MM-DD") : "";
                console.log("Selected Date:", isoDateStr);
                dispatch(
                  changeAppointmentData({ name: "aptdate", value: isoDateStr }),
                );
                dispatch(changeTime(""));
                setActiveSection("morning");
              }}
            />
            {aptDateErr && <div style={errorTextStyle}>Select Date</div>}
          </div>
        )}

        {isWaitListChecked && (
          <>
            {/* Preferred Date */}
            <div style={{ marginBottom: "8px" }}>
              <div style={labelStyle}>Preferred Date</div>

              {/* <AntdDateWrapper> */}
              <DatePicker
                format="MM-DD-YYYY"
                status={dateErr ? "error" : undefined}
                size="middle"
                style={{ width: "100%" }}
                value={
                  waitListExtraInputs.date
                    ? dayjs(waitListExtraInputs.date)
                    : null
                }
                disabledDate={(current) =>
                  current && current < dayjs(patientToday).startOf("day")
                }
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={(date, dateString) => {
                  setDateErr(false);
                  const isoDateStr = date ? date.format("YYYY-MM-DD") : "";
                  setWaitListExtraInputs((prev) => ({
                    ...prev,
                    date: isoDateStr,
                  }));
                }}
              />
              {/* </AntdDateWrapper> */}

              {dateErr && (
                <div
                  style={{
                    color: "#F65160",
                    fontSize: "12px",
                    marginTop: "4px",
                  }}
                >
                  Select Preferred Date
                </div>
              )}
            </div>

            {/* Time Range */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "14px",
                marginBottom: "8px",
              }}
            >
              <div>
                <div style={labelStyle}>From Time</div>
                <TimePicker
                  status={fromTimeError ? "error" : undefined}
                  style={{ width: "100%" }}
                  value={
                    waitListExtraInputs.fromTime
                      ? dayjs(waitListExtraInputs.fromTime, "HH:mm")
                      : null
                  }
                  format="hh:mm A"
                  use12Hours
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={(time) => {
                    const selectedFromTime = time ? time.format("HH:mm") : "";

                    setWaitListExtraInputs((prev) => ({
                      ...prev,
                      fromTime: selectedFromTime,
                    }));

                    setFromTimeError("");

                    if (waitListExtraInputs.date && selectedFromTime) {
                      const fromDateTime = dayjs(
                        `${waitListExtraInputs.date} ${selectedFromTime}`,
                        "YYYY-MM-DD HH:mm",
                      );

                      const patientCurrentDateTime = dayjs(
                        `${patientToday} ${patientNow}`,
                        "YYYY-MM-DD hh:mm A",
                      );

                      if (fromDateTime.isBefore(patientCurrentDateTime)) {
                        setFromTimeError("Cannot select past time");
                      }
                    }
                    validateTimeRange(
                      selectedFromTime,
                      waitListExtraInputs.toTime,
                    );
                  }}
                />
                {fromTimeError && (
                  <div
                    style={{
                      color: "#F65160",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {fromTimeError}
                  </div>
                )}
              </div>

              <div>
                <div style={labelStyle}>To Time</div>
                <TimePicker
                  status={toTimeError ? "error" : undefined}
                  style={{ width: "100%" }}
                  value={
                    waitListExtraInputs.toTime
                      ? dayjs(waitListExtraInputs.toTime, "HH:mm")
                      : null
                  }
                  format="hh:mm A"
                  use12Hours
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={(time) => {
                    const selectedToTime = time ? time.format("HH:mm") : "";

                    setWaitListExtraInputs((prev) => ({
                      ...prev,
                      toTime: selectedToTime,
                    }));

                    validateTimeRange(
                      waitListExtraInputs.fromTime,
                      selectedToTime,
                    );
                  }}
                />
                {toTimeError && (
                  <div
                    style={{
                      color: "#F65160",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {toTimeError}
                  </div>
                )}
              </div>
            </div>

            {/* Priority */}
            <div style={{ marginBottom: "8px" }}>
              <div style={labelStyle}>Priority</div>

              {/* <AntdSelectWrapper> */}
              <Select
                status={priorityErr ? "error" : undefined}
                size="middle"
                style={{ width: "100%" }}
                placeholder="Select Priority"
                value={waitListExtraInputs.priority || undefined}
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={(val) => {
                  setPriorityErr(false);
                  setWaitListExtraInputs((prev) => ({
                    ...prev,
                    priority: val,
                  }));
                }}
              >
                <Option value="Urgent">Urgent</Option>
                <Option value="High">High</Option>
                <Option value="Medium">Medium</Option>
                <Option value="Low">Low</Option>
              </Select>
              {/* </AntdSelectWrapper> */}

              {priorityErr && (
                <div
                  style={{
                    color: "#F65160",
                    fontSize: "12px",
                    marginTop: "4px",
                  }}
                >
                  Select Priority
                </div>
              )}
            </div>
          </>
        )}

        <div style={{ marginBottom: "10px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: isEditing ? "not-allowed" : "pointer",
              opacity: isEditing ? 0.7 : 1,
            }}
            onClick={() => {
              if (!isEditing) {
                setIsWaitListChecked(!isWaitListChecked);
              }
            }}
          >
            <input
              type="checkbox"
              checked={isWaitListChecked}
              disabled={isEditing}
              onChange={(e) => {
                if (!isEditing) {
                  setIsWaitListChecked(e.target.checked);
                }
              }}
              style={{
                width: "16px",
                height: "16px",
                accentColor: "#2C7BE5",
                cursor: isEditing ? "not-allowed" : "pointer",
              }}
            />
            <span
              style={{
                fontSize: "13px",
                fontWeight: 500,
                color: "#374151",
              }}
            >
              Add to Waitlist
            </span>
          </div>
        </div>
        {appointmentData.provider &&
          appointmentData.aptdate &&
          !isWaitListChecked &&
          (loadingProviders ? (
            <div style={{ marginTop: "10px" }}>Loading slots...</div>
          ) : (
            <div style={{ marginBottom: "20px" }}>
              <div style={labelStyle}>Available Time Slots</div>

              {/* Horizontal Section Tabs */}
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: "10px",
                  marginBottom: "15px",
                }}
              >
                {timeSections.map((section) => {
                  const isActive = activeSection === section.key;

                  return (
                    <div
                      key={section.key}
                      onClick={() => setActiveSection(section.key)}
                      style={{
                        padding: "6px 14px",
                        borderRadius: "20px",
                        fontSize: "13px",
                        cursor: "pointer",
                        background: isActive ? "#2C7BE5" : "#f3f4f6",
                        color: isActive ? "#fff" : "#374151",
                        fontWeight: 500,
                      }}
                    >
                      {section.label}
                    </div>
                  );
                })}
              </div>

              {/* Active Section Slots */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
                  gap: "8px",
                }}
              >
                {(availability[activeSection] || []).length > 0 ? (
                  (console.log(
                    "Availability for active section:",
                    availability[activeSection],
                  ),
                  (availability[activeSection] || []).map((slot, index) => {
                    // console.log("Slot data:", slot);
                    const slotTime =
                      slot?.time || slot?.pc_startTime || slot?.start_time;

                    const patientCurrentDateTime = dayjs(
                      `${patientToday} ${patientNow}`,
                      "YYYY-MM-DD hh:mm A",
                    );

                    const isPast =
                      appointmentData.aptdate === patientToday &&
                      dayjs(
                        `${appointmentData.aptdate} ${slotTime}`,
                        "YYYY-MM-DD hh:mm A",
                      ).isBefore(patientCurrentDateTime);
                    const providerObj = providersList?.find(
                      (p) => Number(p.id) === Number(appointmentData.provider)
                    );
                    const providerTimezone = providerObj?.timezone || null;
                    const providerunavailable = isSlotDisabledForPatient(
                      appointmentData.aptdate,
                      slotTime,
                      slot?.disable,
                      availability,
                      providerTimezone
                    );
                    const isSelected = appointmentData.apttime === slotTime;

                    return (
                      <div
                        key={index}
                        onClick={() => {
                          if (!isPast && !providerunavailable) {
                            setAptTimeErr(false);
                            dispatch(changeTime(slotTime));
                            setDuplicateErr(false);
                            dispatch(
                              changeErrorObject({
                                name: "noTime",
                                value: false,
                              }),
                            );
                          }
                        }}
                        style={{
                          textAlign: "center",
                          padding: "8px",
                          borderRadius: "6px",
                          cursor:
                            isPast || providerunavailable
                              ? "not-allowed"
                              : "pointer",
                          fontSize: "12px",
                          border: isSelected
                            ? "1px solid #2C7BE5"
                            : "1px solid #e5e7eb",
                          background:
                            isPast || providerunavailable
                              ? "#f3f4f6"
                              : isSelected
                                ? "#2C7BE5"
                                : "#fff",
                          color:
                            isPast || providerunavailable
                              ? "#9ca3af"
                              : isSelected
                                ? "#fff"
                                : "#374151",
                        }}
                      >
                        {slotTime}
                      </div>
                    );
                  }))
                ) : (
                  <div
                    style={{
                      gridColumn: "1 / -1",
                      padding: "6px",
                      fontSize: "12px",
                      color: "#9ca3af",
                    }}
                  >
                    No slots available
                  </div>
                )}
              </div>
              {aptTimeErr && (
                <div style={errorTextStyle}>Select a time slot</div>
              )}
            </div>
          ))}

        {duplicateErr && (
          <div
            style={{
              color: "#F65160",
              fontSize: "12px",
              marginBottom: "8px",
              padding: "8px 12px",
              background: "#fff1f2",
              borderRadius: "6px",
              border: "1px solid #fecdd3",
            }}
          >
            ⚠️ An appointment already exists at this date and time with the same
            provider. Please select a different slot.
          </div>
        )}
        {/* ---------------- REASON ---------------- */}
        <div style={{ marginBottom: "18px" }}>
          <div style={labelStyle}>Reason for Visit</div>

          <textarea
            style={{
              width: "100%",
              minHeight: "60px",
              maxHeight: "120px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              padding: "10px",
              fontSize: "14px",
              resize: "vertical",
              outline: "none",
            }}
            placeholder="Enter reason"
            value={appointmentData.reason || ""}
            onChange={(e) =>
              dispatch(
                changeAppointmentData({
                  name: "reason",
                  value: e.target.value,
                }),
              )
            }
          />
        </div>

        {/* ---------------- FOOTER ---------------- */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <button
            onClick={() => {
              dispatch(changeTime(""));
              onClose();
            }}
            style={{
              border: "1px solid #2C7BE5",
              background: "#fff",
              color: "#2C7BE5",
              padding: "6px 16px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            Cancel
          </button>

          <button
            disabled={savebtndisabled}
            onClick={() => {
              if (savebtndisabled) return;
              setsavebtndisabled(true);

              if (!pid) {
                alert("Invalid patient ID");
                setsavebtndisabled(false);
                return;
              }

              // Route to Waitlist logic if checked
              if (isWaitListChecked) {
                saveWaitListAppointment();
                return;
              }

              // ── 1. Field Validations (Standard Appointment) ──
              let err = false;

              if (!appointmentData.office) {
                setFacilityErr(true);
                err = true;
              }
              if (!appointmentData.speciality) {
                setSpecialityErr(true);
                err = true;
              }
              if (!appointmentData.appttype) {
                setApptTypeErr(true);
                err = true;
              }
              if (!appointmentData.provider) {
                setProviderErr(true);
                err = true;
              }
              if (
                !appointmentData.aptdate ||
                String(appointmentData.aptdate).trim() === ""
              ) {
                setAptDateErr(true);
                err = true;
              }

              if (!appointmentData.apttime) {
                dispatch(changeErrorObject({ name: "noTime", value: true }));
                setAptTimeErr(true);
                err = true;
              }

              if (err) {
                setsavebtndisabled(false);
                return;
              }

              // ── 2. Duplicate check ──
              if (isDuplicateAppointment()) {
                setDuplicateErr(true);
                setsavebtndisabled(false);
                return;
              }
              setDuplicateErr(false);

              // ── 3. Proceed with save ──
              try {
                const duration = 15;

                const providerObj = providersList?.find(
                  (p) => Number(p.id) === Number(appointmentData.provider),
                );
                const providerTimezone = providerObj?.timezone || null;

                if (!providerTimezone) {
                  dispatch(
                    appointmentSaved({
                      color: "danger",
                      message: "Provider timezone is not configured.",
                    }),
                  );

                  setsavebtndisabled(false);
                  return;
                }

                const patientLocalStart = dayjs(
                  `${appointmentData.aptdate} ${appointmentData.apttime}`,
                  "YYYY-MM-DD hh:mm A",
                );

                const patientLocalEnd = patientLocalStart.add(
                  duration,
                  "minute",
                );

                const baseTime = convertPatientTimeToProviderTime(
                  appointmentData.aptdate,
                  appointmentData.apttime,
                  providerTimezone,
                );

                const endMoment = baseTime.add(duration, "minute");

                const startTime = baseTime.format("hh:mm A");
                const endTime = endMoment.format("hh:mm A");

                const startDate = baseTime.format("YYYY-MM-DD");
                const endDate = endMoment.format("YYYY-MM-DD");

                const seconds = duration * 60;

                const appttypenew =
                  appointmentData.appttype === "Telehealth" ? 2 : 0; // Changed 1 to 0

                const article = {
                  pc_pid: pid,
                  pc_catid: 2,
                  pc_aid: appointmentData.provider,
                  pc_title: appttypenew === 2 ? "Tele Health" : "New Patient",
                  pc_duration: seconds,
                  pc_hometext: "",
                  pc_apptstatus: "not_confirmed",
                  pc_eventDate: startDate,
                  pc_endDate: endDate,
                  pc_startTime: startTime,
                  pc_endTime: endTime,
                  patient_local_date: patientLocalStart.format("YYYY-MM-DD"),

                  patient_local_start_time: patientLocalStart.format("hh:mm A"),

                  patient_local_end_date: patientLocalEnd.format("YYYY-MM-DD"),

                  patient_local_end_time: patientLocalEnd.format("hh:mm A"),

                  appointment_time_source: "patient_portal",
                  pc_facility: appointmentData.office,
                  pc_informant: appointmentData.provider,
                  pc_billing_location: bill_facility_id || 0,
                  pc_select1: 0,
                  pc_select2: 0,
                  pc_untildate: "",
                  pc_fromdate: startDate,
                  pc_todate: startDate,
                  days_wise: false,
                  allday: false,
                  repeats: "",
                  appttype: appttypenew,
                  walkin: false,
                  encounter: appointmentData.encounter || 0,
                  eid: appointmentData.eid || "",
                  patient_reason: appointmentData.reason,
                  speciality: appointmentData.speciality,
                };

                if (!appointmentData.eid || appointmentData.eid === 0) {
                  console.log("article", article);
                  dispatch(addAppointment(article));
                } else {
                  dispatch(AppointmentEdited(article));
                }
                dispatch(GetUpcomingAppointment({ pid }));
                onClose();
              } catch (error) {
                console.error("Error during save:", error);
                alert("An error occurred during save: " + error.message);
                setsavebtndisabled(false);
              }

              // dispatch(clearAppointmentData(""));
            }}
            style={{
              background: "#2C7BE5",
              color: "#fff",
              padding: "6px 18px",
              borderRadius: "6px",
              border: "none",

              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
};

export default AddAppointmentFormModal;
